import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_RECEIPTS = 'FETCH_RECEIPTS'
export const FETCH_RECEIPTS_SUCCESS = 'FETCH_RECEIPTS_SUCCESS'
export const FETCH_RECEIPTS_FAILURE = 'FETCH_RECEIPTS_FAILURE'
export const SAVE_RECEIPTS_SUCCESS = 'SAVE_RECEIPTS_SUCCESS'
export const SAVE_RECEIPTS_FAILURE = 'SAVE_RECEIPTS_FAILURE'
export const RECEIPTS_AJAX_CALL = 'RECEIPTS_AJAX_CALL'
export const RECEIPTS_CLEAR_AJAX_CALL = 'RECEIPTS_CLEAR_AJAX_CALL'
export const DELETE_RECEIPTS_SUCCESS = 'DELETE_RECEIPTS_SUCCESS'
export const DELETE_RECEIPTS_FAILURE = 'DELETE_RECEIPTS_FAILURE'

export function loadReceipts() {
  return (dispatch) => {
    dispatch(fetchReceipts())
    axios({
      method: 'GET',
      url: URIS.receipts,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchReceiptsSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchReceiptsFailure(errorMessage(error)))
      })
  }
}

function fetchReceipts() {
  return {
    type: FETCH_RECEIPTS
  }
}

function fetchReceiptsSuccess(payload) {
  return {
    type: FETCH_RECEIPTS_SUCCESS,
    payload
  }
}

function fetchReceiptsFailure(payload) {
  return {
    type: FETCH_RECEIPTS_FAILURE,
    payload
  }
}

export function saveReceipts(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.receipts,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveReceiptsSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveReceiptsFailure(errorMessage(error)))
      })
  }
}

function saveReceiptsSuccess(payload) {
  return {
    type: SAVE_RECEIPTS_SUCCESS,
    payload
  }
}

export function saveReceiptsFailure(payload) {
  return {
    type: SAVE_RECEIPTS_FAILURE,
    payload
  }
}

export function deleteReceipts(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'DELETE',
      url: URIS.receipts,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(deleteReceiptsSuccess(res.data))
      })
      .catch((error) => {
        dispatch(deleteReceiptsFailure(errorMessage(error)))
      })
  }
}

function deleteReceiptsSuccess(payload) {
  return {
    type: DELETE_RECEIPTS_SUCCESS,
    payload
  }
}

export function deleteReceiptsFailure(payload) {
  return {
    type: DELETE_RECEIPTS_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: RECEIPTS_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: RECEIPTS_CLEAR_AJAX_CALL
  }
}



// WEBPACK FOOTER //
// ./src/actions/Receipts.js